import React, { FC } from 'react'
import { FilterComponentProp } from '../../forms/hocs/types'
import { FieldsetPanel } from '../fieldset-panel/fieldset-panel'

export const MobileFacet: FC<FilterComponentProp> = (props) => {
    return <FieldsetPanel title={props.title || ''}>{props.children}</FieldsetPanel>
}
